import { observer } from "mobx-react";

import CreateModal from "@component/CreateModal";
import Note from "@model/Note";
import NoteCreateVM from "@vm/Create/Note";

import NoteForm from "./Form";
import { lazyInject, TYPES } from "../../../inversify.config";

@observer
export default class NoteCreate extends CreateModal<Note> {
  modelName = "note";
  prefix = "employee";

  @lazyInject(TYPES.NoteCreate)
  vm: NoteCreateVM;

  componentDidMount(): void {
    this.vm.setParentId(this.props.match.params.user_id);
    super.componentDidMount();
  }

  onClose = () => {
    this.router.pageLink(this.uriHelper.employees_notes(this.props.match.params.user_id));
  };

  renderModalBody() {
    return (
      <>
        <NoteForm entity={this.vm.entity} />
      </>
    );
  }
}
